import React from 'react';
import { Table } from 'antd';
import OperatorForkliftActions from './OperatorForkliftActions';
import OperatorForkliftAvailability from './OperatorForkliftAvailability';

export default function OperatorForkliftDesktopTable({
  busy,
  forklifts,
  onSafetyReport,
  onSelect,
  onStartChecklist,
  selectedRowId,
}) {
  const columns = [
    {
      title: 'Unit ID',
      dataIndex: 'unitId',
      key: 'unitId',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Make',
      dataIndex: 'make',
      key: 'make',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Serial #',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
    },
    {
      title: 'Availability',
      key: 'availability',
      render: (_, record) => <OperatorForkliftAvailability forklift={record} />,
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      className: 'operator-forklift-actions-cell',
      width: 210,
      render: (_, record) => (
        <OperatorForkliftActions
          busy={busy}
          forklift={record}
          onSafetyReport={onSafetyReport}
          onStartChecklist={onStartChecklist}
        />
      ),
    },
  ];

  return (
    <div className="operator-forklift-table-wrap">
      <Table
        rowKey="id"
        dataSource={forklifts}
        columns={columns}
        loading={busy}
        pagination={false}
        size="middle"
        locale={{ emptyText: 'No forklifts found.' }}
        rowClassName={(record) => (record.id === selectedRowId ? 'ant-table-row-selected' : '')}
        onRow={(record) => ({
          onClick: () => onSelect(record.id),
        })}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}
